import { ByocUploadContentService } from './../../service/upload-content.service';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { MessageService } from '@app/service/message.service';
import { ByocService } from '@app/byoc/popup/service/byoc.service';
import { ByocEpisodeService } from '../../service/episode.service';
import { Course } from '@app/core/model/library.model';

@Component({
    selector: 'app-byoc-episode-step-position',
    templateUrl: './position.component.html',
    styleUrls: ['./position.component.scss'],
    standalone: false
})
export class ByocEpisodeStepPositionComponent implements OnInit, OnDestroy {
    course!: Course;

    loaded = false;
    loadedList = false;
    saving = false;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private router: Router,
        private changeDetectorRef: ChangeDetectorRef,
        private translateService: TranslateService,
        private messageService: MessageService,
        private byocService: ByocService,
        private byocEpisodeService: ByocEpisodeService,
        private readonly byocUploadContentService: ByocUploadContentService,
    ) {}

    ngOnInit() {
        this.subscriptions.add(
            this.byocService.course(<string>this.byocEpisodeService.form.value.courseId).subscribe((course: Course) => {
                this.course = course;
                this.loaded = true;
                this.changeDetectorRef.detectChanges();
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Loaded Inner List
     */
    listLoaded($event: boolean) {
        this.loadedList = $event;
    }

    /**
     * Cancel
     */
    cancelClick(): void {
        this.byocEpisodeService.close('btn-close');
    }

    /**
     * Back to previous step
     */
    backClick(): void {
        if (this.byocEpisodeService.skipSteps.includes('course')) {
            this.byocEpisodeService.step = 'general';
        } else {
            this.byocEpisodeService.step = 'course';
        }
        this.changeDetectorRef.markForCheck();
    }

    /**
     * Save as Draft
     */
    saveAsDraftClick(): void {
        if (!this.loaded || !this.loadedList) {
            return;
        }

        // set as draft
        this.byocEpisodeService.form.patchValue({ status: 1 });

        // show loader
        this.saving = true;
        this.changeDetectorRef.detectChanges();

        // save as draft
        this.subscriptions.add(
            this.byocService
                .createEpisode(this.byocEpisodeService.getEpisodeDataToSent())
                .pipe(
                    tap(() => {
                        if (this.byocUploadContentService.uploadType) {
                            this.byocEpisodeService.step = 'uploaded-content-info';
                            this.changeDetectorRef.markForCheck();
                        } else if (this.router.url === '/manager/settings/content/byoc/list') {
                            this.messageService.setMessage(this.translateService.instant('v3-byoc-popup-create-episode-alert-save-as-draft'), 'info');
                            this.byocEpisodeService.close('btn-close');
                        } else {
                            this.messageService.setRouteMessage(this.translateService.instant('v3-byoc-popup-create-episode-alert-save-as-draft'), 'info');
                            this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'list']);
                        }
                    }),
                )
                .subscribe(),
        );
    }

    /**
     * Publish Click
     */
    usersClick(): void {
        if (!this.loaded || !this.loadedList) {
            return;
        }
        this.byocEpisodeService.form.patchValue({ status: 2 });
        this.byocEpisodeService.step = 'users';
    }
}
